import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authed/ops/')({
  beforeLoad: () => {
    throw redirect({ to: '/ops/inbox' });
  },
});
